import './link-list.scss';

import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { NavLink } from '@sola/ark-core/atoms/link/nav-link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import type { NavigationProps } from '@sola/schema/lib/schema.ts';

type LinkListProps = {
  item: NavigationProps;
  usePadding?: boolean;
  useHover?: boolean;
  variant?: 'navigation' | 'menu';
  className?: string;
  linkClassName?: string;
};

export const LinkList: React.FC<LinkListProps> = ({
  item,
  usePadding = false,
  useHover = false,
  variant = 'menu',
  className,
  linkClassName,
}) => {
  const listHasIcon = item?.items?.some((i) => Boolean(i.icon));

  return (
    <ul
      className={cn(
        'LinkList flex flex-col',
        `LinkList--${variant}`,
        className,
      )}
    >
      {item.items?.map((i) => {
        if (i.renderOverride) {
          return (
            <li key={i?.title} className="flex gap-snug-xl label items-center">
              {i.renderOverride}
            </li>
          );
        }
        return (
          <li key={i?.title} className="flex gap-snug-xl label items-center">
            {/* TODO: items could override the color, or we keep it static */}
            <LinkStyle size="sm" purpose="neutral" noUnderline>
              <NavLink
                href={i?.link || '#'}
                target={i?.target}
                title={i?.title}
                className={cn(
                  'LinkList__menu-link w-full label-neutral flex gap-snug-xl',
                  {
                    'LinkList__menu-link--hover': useHover,
                    'justify-between items-center': variant !== 'menu',
                  },
                  linkClassName,
                )}
                isCurrentOnChildPages={i.isCurrentOnChildPages}
              >
                <div
                  className={cn('flex', {
                    'gap-comfy-xs': variant === 'menu',
                    'gap-snug-xl w-full': variant !== 'menu',
                  })}
                >
                  {i?.icon && (
                    <ArkIcon iconName={i?.icon} className="LinkList__icon" />
                  )}

                  {usePadding && !listHasIcon && (
                    <span className="LinkList__icon" />
                  )}

                  <span className="LinkList__text label flex gap-snug-xl items-center">
                    {i?.title}
                  </span>
                </div>

                {i.badge?.text && (
                  <Badge
                    label={i.badge?.text}
                    color={i.badge?.color}
                    size="sm"
                  />
                )}
              </NavLink>
            </LinkStyle>
          </li>
        );
      })}
    </ul>
  );
};
